<template>
  <div>
    <div class="flex flex-col md:flex-row justify-between">

      <div class="flex items-center">

        <div class="block">
          <portal to="search">
            <div class="w-full h-full flex flex-row items-center">
              <div class="relative w-full text-gray-400 focus-within:text-gray-600">
                <div class="absolute inset-y-0 left-0 flex items-center pointer-events-none">
                  <svg class="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" />
                  </svg>
                </div>
                <input v-model="searchText" class="block w-full h-full pl-8 pr-3 py-2 rounded-md text-gray-900 placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 text-base" placeholder="Search" type="search">
              </div>
            </div>
          </portal>
          <portal to="quickActions" >
            <div class="flex mx-3 items-center">
              <div class="hidden md:block">
                <div class="flex flex-col md:flex-row md:items-center">
                  <label class="block text-sm font-medium leading-5 text-gray-700 md:mr-3">
                    Shopping Location
                  </label>
                  <div class="flex rounded-md shadow-sm">
                    <select v-model="shopping_location" class="block form-select w-full transition duration-150 ease-in-out sm:text-sm">
                      <option v-for="(shopLocation, slkey) in addressConfig.shopping_locations" :value="slkey">{{ shopLocation }}</option>
                    </select>
                  </div>
                </div>
              </div>

              <inertia-link :href="this.route('customer.cart')" class="block flex btn-primary uppercase py-2 ml-2 px-3 relative">
                <span v-if="storeForm.items.length" class="bg-green-400 text-white rounded-full absolute right-0 top-0 mt-1 ml-1 text-xs p-1 transform -translate-y-1/2 translate-x-1/2">{{ storeForm.items.length }}</span>
                <span v-else class="bg-gray-400 text-white rounded-full absolute right-0 top-0 mt-1 ml-1 text-xs p-1 transform -translate-y-1/2 translate-x-1/2">0</span>
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"></path></svg>
                <span class="hidden md:block">Cart</span>
              </inertia-link>

            </div>
          </portal>
        </div>
      </div>
    </div>

    <div class="bg-yellow-50 border-l-4 border-yellow-400 p-2 mb-2 rounded" v-if="dailyLimitEnabled">
      <div class="flex">
        <div class="flex-shrink-0">
          <svg class="h-5 w-5 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/>
          </svg>
        </div>
        <div class="ml-3">
          <p class="text-sm leading-5 text-yellow-700">
            {{ dailyLimitNotice }}
          </p>
        </div>
      </div>
    </div>



    <div class="flex flex-col md:flex-row sm:-px-4 lg:-mx-4">

      <div class="block md:hidden">
        <div class="flex flex-col md:flex-row md:items-center">
          <label class="block text-sm font-medium leading-5 text-gray-700 md:mr-3">
            Shopping Location
          </label>
          <div class="flex rounded-md shadow-sm">
            <select v-model="shopping_location" class="block form-select w-full transition duration-150 ease-in-out sm:text-sm">
              <option v-for="(shopLocation, slkey) in addressConfig.shopping_locations" :value="slkey">{{ shopLocation }}</option>
            </select>
          </div>
        </div>
      </div>

      <div class="md:block w-full order-2 md:order-1 lg:w-full px-1 lg:px-4">
        <product-catalog :useSearchText="true" :searchText="searchText" is-customer :enable-product-unit-selection="enableProductUnitSelection" :location="shopping_location" :key="shopping_location" />
      </div>
    </div>
  </div>
</template>



<script>
  import Layout from '@/Shared/Customers/Layout'
  import Toggle from '@/Shared/Toggle'
  import ProductCatalog from '@/Pages/Customers/Store/ProductCatalog'
  import Icon from '@/Shared/Icon'
  import LoadingButton from '@/Shared/LoadingButton'
  import Modal from '@/Shared/Modal'
  import TextInput from '@/Shared/TextInput'

  import store from '@/Pages/Customers/Store/store.js'

  store.setCustomerMode()

  export default {
  layout: Layout,
  name: 'Create',
  components: {
    TextInput,
    Modal, LoadingButton, Icon, ProductCatalog, Toggle
  },

  props: {
    addressConfig: {
      type: Object,
    },
    enableProductUnitSelection: Boolean,
    dailyLimitEnabled: Boolean,
    dailyLimitNotice: String,
  },

  data() {
    return {
      storeForm: store.form,
      searchText: null,
      shopping_location: null,
    }
  },

  watch: {
    'shopping_location': function(val) {
      localStorage.setItem('my.defaultShoppingLocation', val)
    }
  },

  mounted() {
    store.setHttpClient(this.$http)
    // set default shopping location
    this.shopping_location = localStorage.getItem('my.defaultShoppingLocation') || this.addressConfig.shoppingDefaultLocation
    store.reloadCart(this.shopping_location)
  }
}
</script>

